module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll",
      value: ({
        always: false
      }),
      expression: "{ always: false }"
    }],
    staticClass: "chat"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message.MessageId
    }, [(message.IsSitter) ? _c('li', {
      staticClass: "right"
    }, [_c('span', {
      staticClass: "chat-img pull-left"
    }), _vm._v(" "), _c('div', {
      staticClass: "chat-body clearfix"
    }, [_c('p', {
      staticClass: "chat-from"
    }, [_vm._v("\n              " + _vm._s(message.MessageText) + "\n              "), _c('small', {
      staticClass: "pull-right",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-time"
    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])]) : _c('li', {
      staticClass: "left clearfix"
    }, [_c('span', {
      staticClass: "chat-img pull-right"
    }), _vm._v(" "), _c('div', {
      staticClass: "chat-body clearfix"
    }, [_c('p', {
      staticClass: "chat-to"
    }, [_vm._v("\n              " + _vm._s(message.MessageText)), _c('small', {
      staticClass: "pull-right",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-time"
    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input-text",
    attrs: {
      "disabled": _vm.preventChat,
      "placeholder": "",
      "row": "3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon btn",
    attrs: {
      "disabled": _vm.preventChat
    }
  }, [_vm._v("Send")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ece92b36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Components/ChatHistory.vue
// module id = 663
// module chunks = 2